// src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerManual.jsx
import React, { useEffect, useState } from 'react';
import styles from './styles/ScannerManual.module.css';
import api from '../../../../../services/api';
import { useRouteStore } from '../../../Route/useRouteStore';
import DataMatrixBarcode from './DataMatrixBarcode';

export default function ScannerManual({ onMarkScanned }) {
  const receipt = useRouteStore(s => s.selectedReceipt);
  const [marks, setMarks] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [productMap, setProductMap] = useState({});
  const [selectedSet, setSelectedSet] = useState(new Set());
  const [searchSerial, setSearchSerial] = useState('');
  const [searchDate, setSearchDate] = useState('');

  // 1) Загрузка каталога продуктов
  useEffect(() => {
    api.get('/catalog-product/products')
      .then(list => {
        const map = {};
        list.forEach(p => {
          const key = String(p.gtin ?? p.code ?? '');
          const name = p.product_name ?? p.name ?? 'Неизвестно';
          if (key) map[key] = name;
        });
        setProductMap(map);
      })
      .catch(console.error);
  }, []);

  // 2) Загрузка марок по маршруту
  useEffect(() => {
    if (!receipt?.routeListId) return;
    api.get(`/marks/by-route/${receipt.routeListId}`)
      .then(list => {
        setMarks(list);
        setFiltered(list);
      })
      .catch(console.error);
  }, [receipt]);

  // 3) Фильтрация по началу serial_number и дате
  useEffect(() => {
    let f = marks;
    if (searchSerial) {
      f = f.filter(item =>
        String(item.serial_number).startsWith(searchSerial)
      );
    }
    if (searchDate) {
      f = f.filter(item =>
        item.mark_date?.split('T')[0] === searchDate
      );
    }
    setFiltered(f);
  }, [searchSerial, searchDate, marks]);

  const toggle = code => {
    setSelectedSet(prev => {
      const next = new Set(prev);
      next.has(code) ? next.delete(code) : next.add(code);
      return next;
    });
  };

  // 4) При подтверждении отправляем каждый код с задержкой 500мс
  const handleSubmit = async () => {
    for (const code of selectedSet) {
      try {
        await onMarkScanned(code);
      } catch (e) {
        console.error('Ошибка при отправке метки', code, e);
      }
      // ждем 500 мс перед следующим
      await new Promise(resolve => setTimeout(resolve, 30));
    }
    // сбрасываем выбор
    setSelectedSet(new Set());
  };

  return (
    <div className={styles.manualContainer}>
      {/* Поиск по № и дате */}
      <div className={styles.filters}>
        <input
          type="number"
          min="1"
          placeholder="Поиск по №"
          value={searchSerial}
          onChange={e => setSearchSerial(e.target.value)}
          className={styles.input}
        />
        <input
          type="date"
          value={searchDate}
          onChange={e => setSearchDate(e.target.value)}
          className={styles.input}
        />
      </div>

      {/* Список марок с прокруткой */}
      <div className={styles.listContainer}>
        {filtered.length === 0 ? (
          <p className={styles.empty}>Нет марок для отображения.</p>
        ) : (
          filtered.map((item, idx) => {
            const { mark_code, serial_number, mark_date } = item;
            const gtinKey = String(item.gtin ?? item.code ?? '');
            const date = mark_date?.split('T')[0] || '';
            const name = productMap[gtinKey] ?? 'Неизвестно';
            const isSelected = selectedSet.has(mark_code);

            return (
              <div
                key={idx}
                className={`${styles.markItem} ${isSelected ? styles.selected : ''}`}
                onClick={() => toggle(mark_code)}
              >
                <div className={styles.serialText}>#{serial_number}</div>
                <DataMatrixBarcode value={mark_code} size={80} />
                <div className={styles.nameText}>{name}</div>
                <div className={styles.dateText}>{date}</div>
                {isSelected && <div className={styles.checkOverlay}>✓</div>}
              </div>
            );
          })
        )}
      </div>

      {/* Кнопка подтверждения */}
      <button
        className={styles.submitBtn}
        disabled={selectedSet.size === 0}
        onClick={handleSubmit}
      >
        Подтвердить ({selectedSet.size})
      </button>
    </div>
  );
}
